<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="User"
              bc1="App"
              bc2="User"
              bc3="Details"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="backTo"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <section class="app-user-list">
          <div class="card" v-if="!isEmpty(userRoles)">
            <div class="card-header">
              <h4 class="card-title">
                User Roles
              </h4>
            </div>
            <div class="card-body">
              <div class="row ">
                <div class="col-md-12 col-12">
                  <div class="card border-primary border-darken-4 badge-glow">
                    <div class="card-body">
                      <div class="row pb-2 ">
                        <div class="col-4 mt-2" v-for="(role,roleIndex) in userRoles" :key="roleIndex">
                          <span class="bullet bullet-warning font-small-3 mr-50 cursor-pointer"></span>
                          <span>{{ role.role.name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section v-if="!isEmpty(accounts)" >
            <div class="row">
              <div class="col-sm-12">
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title">Accounts Details</h4>
                  </div>
                  <div class="card-body">
                    <div class="row mt-5">
                      <div class="col-12">
                        <div class="card">
                          <div class="table-responsive">
                            <table class="table">
                              <thead>
                              <tr>
                                <th>Account Number</th>
                                <th>Account Title</th>
                                <th>Balance</th>
                                <th>Balance On Hold</th>
                                <th>Available Balance</th>
                                <th>Status</th>
                                <th>Creation Time/Date</th>
                                <th>Action</th>

                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="(account,accountIndex) in accounts" :key="accountIndex">
                                <td>{{ account.account_number }}</td>
                                <td><span class="badge badge-glow badge-info">{{ account.account_title }}</span></td>
                                <td><span  class=" font-weight-bolder text-dark">{{modifyAmount(parseFloat(account.balance / 100).toFixed(3))}}</span><br><span class="badge badge-light-success">{{account.currency.code}}</span>
                                  <br> <span class="badge badge-light-primary mt-sm-1" style="cursor: pointer" @click="$router.push({name: 'account-ledger',params: {id:account.id}})">show ledger</span>
                                </td>
                                <td ><span  class=" font-weight-bolder text-dark">{{modifyAmount(parseFloat(account.balance_on_hold / 100).toFixed(3))}}</span><br><span class="badge badge-light-success ">{{account.currency.code}}</span>
                                  <br> <span class="badge badge-light-primary mt-sm-1" style="cursor: pointer" @click="$router.push({name: 'balance-on-hold',params: {id:account.id, uuid: uuid}})">show ledger</span>
                                </td>
                                <td ><span  class=" font-weight-bolder text-dark">{{modifyAmount(parseFloat(account.available_balance / 100).toFixed(3))}}</span><br><span class="badge badge-light-success ">{{account.currency.code}}</span></td>

                                <td v-if="account.status == 1"><span class="badge badge-success badge-glow badge-sm">Active</span></td>
                                <td v-else-if="account.status == 2"><span class="badge badge-danger badge-glow badge-sm">Inactive</span></td>
                                <td v-else-if="account.status == 3"><span class="badge badge-info badge-glow badge-sm">Suspended</span></td>
                                <td v-else-if="account.status == 4"><span class="badge badge-primary badge-glow badge-sm">Closed</span></td>
                                <td v-else><span class="badge badge-dark badge-glow badge-sm">Pending</span></td>

                                <td ><span  class=" font-weight-bolder text-dark">{{customFormatDateTime(account.created_at)}}</span></td>
                                <td class="d-flex">
<!--                                  <button class="btn btn-sm btn-warning btn-sm" @click="$router.push({name: 'account-ledger',params: {id:account.id}})">Ledger</button>-->
<!--                                  <button class="btn btn-sm btn-primary ml-1 btn-sm" @click="$router.push({name: 'balance-on-hold',params: {id:account.id}})">HoldBalance</button>-->
                                  <button v-if="account.status != 4" class="btn btn-sm btn-primary btn-sm mt-1" @click="updateStatus(account,accountIndex)">Status</button>
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section v-if="!isEmpty(cards)">
            <div class="row">
              <div class="col-sm-12">
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title">Cards Details</h4>
                  </div>
                  <div class="card-body">
                    <div class="row mt-5">
                      <div class="col-12">
                        <div class="card">
                          <div class="table-responsive">
                            <table class="table">
                              <thead>
                              <tr>
                                <th>Card Number</th>
                                <th>Card Holder Name</th>
                                <th>Type</th>

                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="(card,cardIndex) in cards" :key="cardIndex">
                                <td>{{ card.card_number }}</td>
                                <td><span class="badge badge-glow badge-info">{{ card.card_holder_name }}</span></td>
                                <td v-if="card.card_type"><span class="badge badge-glow badge-warning">{{ card.card_type }}</span></td>
                                <td class="font-weight-bolder" v-else>-</td>


                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

<!--          <section id="basic-horizontal-layouts" v-if="!isEmpty(userkycs)">-->
<!--            <div class="row">-->
<!--              <div class="col-md-12 col-12">-->
<!--                <div class="card border-primary badge-glow">-->
<!--                  <div class="card-header">-->
<!--                    <h4 class="card-title">User Kyc Details</h4>-->
<!--                  </div>-->
<!--                  <div class="card-body">-->
<!--                    <div class="row bg" v-for="(eachUserkycsArrayElement,eachUserkycsArrayElementIndex) in userkycs" :key="eachUserkycsArrayElementIndex">-->
<!--                      <div  class="col-12">-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3">-->
<!--                            <p class="text-dark font-weight-bolder">Applicant Id</p>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <div class="input-group">-->
<!--                              <p class="text-primary">{{eachUserkycsArrayElement.applicant_id}}</p>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div  class="col-12">-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3">-->
<!--                            <p class="text-dark font-weight-bolder">Status</p>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <div class="input-group">-->
<!--&lt;!&ndash;                              <p class="text-primary" v-if="eachUserkycsArrayElement.status == 0" >Created Docs Pending</p>&ndash;&gt;-->
<!--&lt;!&ndash;                              <p class="text-success" v-else-if="eachUserkycsArrayElement.status == 1" >Ok</p>&ndash;&gt;-->
<!--&lt;!&ndash;                              <p class="text-warning" v-else-if="eachUserkycsArrayElement.status == 2" >Pending</p>&ndash;&gt;-->
<!--&lt;!&ndash;                              <p class="text-info" v-else-if="eachUserkycsArrayElement.status == 3" >Retry</p>&ndash;&gt;-->
<!--&lt;!&ndash;                              <p class="text-danger" v-else-if="eachUserkycsArrayElement.status == 4" >Blocked</p>&ndash;&gt;-->

<!--                              <p class="text-warning" v-if="eachUserkycsArrayElement.status == 0" >Pending</p>-->
<!--                              <p class="text-success" v-else-if="eachUserkycsArrayElement.status == 1" >Approved</p>-->
<!--                              <p class="text-danger" v-else-if="eachUserkycsArrayElement.status == 2" >Reject</p>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div  class="col-12" v-if="eachUserkycsArrayElement.reason">-->
<!--                        <div class="form-group row">-->
<!--                          <div class="col-sm-3">-->
<!--                            <p class="text-dark font-weight-bolder">Reason</p>-->
<!--                          </div>-->
<!--                          <div class="col-sm-9">-->
<!--                            <div class="input-group">-->
<!--                              <span class="badge badge-glow badge-light-dark" :class="reasonIndex >0?'ml-sm-1':''" v-for="(reasonItem,reasonIndex) in JSON.parse(eachUserkycsArrayElement.reason)" >-->
<!--                                {{reasonItem}}-->
<!--                              </span>-->
<!--                            </div>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div  class="col-12 d-flex justify-content-end">-->
<!--                        <button type="button" class="btn btn-primary btn-sm " @click="updateKycStatus(eachUserkycsArrayElement,eachUserkycsArrayElementIndex)">Update Status</button>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </section>-->
          <section id="basic-horizontal-layouts">
            <div class="row">
              <div class="col-md-12 col-12">
                <div class="card border-primary badge-glow">
                  <div class="card-header">
                    <h4 class="card-title">User Kyc Details</h4>
                  </div>
                  <div class="card-body table-responsive ">
                    <div class="row">
                      <table v-if="!isEmpty(userkycs)" class="table table-head-fixed table-hover-animation text-nowrap">
                        <thead>
                        <tr>
                          <th>S.no</th>
                          <th>Applicant Id</th>
                          <th>Status</th>
                          <th>Updated By</th>
                          <th>Reason</th>
                          <th>Updated At</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr  v-for="(eachUserkycsArrayElement,eachUserkycsArrayElementIndex) in userkycs" :key="eachUserkycsArrayElementIndex">
                          <td>{{ eachUserkycsArrayElementIndex + 1 }}</td>
                          <td><span class="text-primary">{{eachUserkycsArrayElement.applicant_id}}</span></td>
                          <td>
                            <span class="text-warning" v-if="eachUserkycsArrayElement.status == 2" >Pending</span>
                            <span class="text-success" v-else-if="eachUserkycsArrayElement.status == 1" >Verified</span>
                            <span class="text-info" v-else-if="eachUserkycsArrayElement.status == 3" >Upload Document Again</span>
                            <span class="text-danger" v-else-if="eachUserkycsArrayElement.status == 4" >Blocked</span>
                            <span class="text-dark" v-else-if="eachUserkycsArrayElement.status == 0" >Initiated</span>
                          </td>
                          <td>{{eachUserkycsArrayElement.updated_by_user?eachUserkycsArrayElement.updated_by_user.email: 'Auto'}}</td>
                          <td>{{eachUserkycsArrayElement.reason?eachUserkycsArrayElement.reason:'N/A'}}</td>
                          <td>{{ new Date(typeof(eachUserkycsArrayElement.updated_at) != 'undefined'?eachUserkycsArrayElement.updated_at: eachUserkycsArrayElement.created_at).toISOString().slice(0, 16).replace("T", " ") }}</td>
                        </tr>
                        </tbody>
                      </table>
                      <div class="col-12" v-else>
                        <div class="alert alert-danger" role="alert" >
                          <div class="alert-body">
                            <p class="text-center"> KYC process not initiated yet.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="row">
                    <div  class="col-12 d-flex justify-content-end p-2">
                      <button type="button" class="btn btn-primary btn-sm " @click="updateKycStatus">Update Status</button>
                    </div>
                  </div>


                  <!--                  <div class="card-body">-->
                  <!--                    <div class="row bg" v-for="(eachUserkycsArrayElement,eachUserkycsArrayElementIndex) in userkycs" :key="eachUserkycsArrayElementIndex">-->
                  <!--                      <div  class="col-12">-->
                  <!--                        <div class="form-group row">-->
                  <!--                          <div class="col-sm-3">-->
                  <!--                            <p class="text-dark font-weight-bolder">Applicant Id</p>-->
                  <!--                          </div>-->
                  <!--                          <div class="col-sm-9">-->
                  <!--                            <div class="input-group">-->
                  <!--                              <p class="text-primary">{{eachUserkycsArrayElement.applicant_id}}</p>-->
                  <!--                            </div>-->
                  <!--                          </div>-->
                  <!--                        </div>-->
                  <!--                      </div>-->
                  <!--                      <div  class="col-12">-->
                  <!--                        <div class="form-group row">-->
                  <!--                          <div class="col-sm-3">-->
                  <!--                            <p class="text-dark font-weight-bolder">Status</p>-->
                  <!--                          </div>-->
                  <!--                          <div class="col-sm-9">-->
                  <!--                            <div class="input-group">-->
                  <!--&lt;!&ndash;                              <p class="text-primary" v-if="eachUserkycsArrayElement.status == 0" >Created Docs Pending</p>&ndash;&gt;-->
                  <!--&lt;!&ndash;                              <p class="text-success" v-else-if="eachUserkycsArrayElement.status == 1" >Ok</p>&ndash;&gt;-->
                  <!--&lt;!&ndash;                              <p class="text-warning" v-else-if="eachUserkycsArrayElement.status == 2" >Pending</p>&ndash;&gt;-->
                  <!--&lt;!&ndash;                              <p class="text-info" v-else-if="eachUserkycsArrayElement.status == 3" >Retry</p>&ndash;&gt;-->
                  <!--&lt;!&ndash;                              <p class="text-danger" v-else-if="eachUserkycsArrayElement.status == 4" >Blocked</p>&ndash;&gt;-->

                  <!--                              <p class="text-warning" v-if="eachUserkycsArrayElement.status == 0" >Pending</p>-->
                  <!--                              <p class="text-success" v-else-if="eachUserkycsArrayElement.status == 1" >Approved</p>-->
                  <!--                              <p class="text-danger" v-else-if="eachUserkycsArrayElement.status == 2" >Reject</p>-->

                  <!--                            </div>-->
                  <!--                          </div>-->
                  <!--                        </div>-->
                  <!--                      </div>-->
                  <!--                      <div  class="col-12" v-if="eachUserkycsArrayElement.reason">-->
                  <!--                        <div class="form-group row">-->
                  <!--                          <div class="col-sm-3">-->
                  <!--                            <p class="text-dark font-weight-bolder">Reason</p>-->
                  <!--                          </div>-->
                  <!--                          <div class="col-sm-9">-->
                  <!--                            <div class="input-group">-->
                  <!--                              <span class="badge badge-glow badge-light-dark" :class="reasonIndex >0?'ml-sm-1':''" v-for="(reasonItem,reasonIndex) in JSON.parse(eachUserkycsArrayElement.reason)" >-->
                  <!--                                {{reasonItem}}-->
                  <!--                              </span>-->
                  <!--                            </div>-->
                  <!--                          </div>-->
                  <!--                        </div>-->
                  <!--                      </div>-->
                  <!--                      <div  class="col-12 d-flex justify-content-end">-->
                  <!--                        <button type="button" class="btn btn-primary btn-sm " @click="updateKycStatus(eachUserkycsArrayElement,eachUserkycsArrayElementIndex)">Update Status</button>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                </div>
              </div>
            </div>
          </section>

        </section>
        <!-- users list ends -->

      </div>
    </div>
    <MerchantAccountUpdateStatusModal
        :show="showModal"
        :id="accountId"
        :status="accountStatus"
        :row="accountRow"
        :index="accountIndex"
        @hide="showModal = false"
        @statusUpdated="statusUpdated"
    ></MerchantAccountUpdateStatusModal>
    <MerchantKycUpdateStatusModal
      :show="showKycModal"
      :id="kycId"
      :row="kycRow"
      :userkycs="userkycs"
      :index="kycIndex"
      @hide="showKycModal = false"
      @statusUpdated="kycStatusUpdated"
    ></MerchantKycUpdateStatusModal>
  </div>
</template>

<script>

import MerchantAccountUpdateStatusModal from "@/pages/dashboard/merchant/MerchantAccountUpdateStatusModal";
import MerchantKycUpdateStatusModal from "@/pages/dashboard/merchant/MerchantKycUpdateStatusModal";
export default {
  props: ['propFilters'],
  components:{
    MerchantAccountUpdateStatusModal,MerchantKycUpdateStatusModal
  },
  mounted() {
    this.sendCall()
  },
  data() {
    return {
      userRoles: [],
      accounts: [],
      cards: [],
      userkycs: [],
      accountId:'',
      accountStatus:'',
      accountIndex:'',
      accountRow:'',
      showModal: false,
      showKycModal: false,
      kycId:'',
      kycStatus:'',
      kycIndex:'',
      kycRow:'',
      uuid: '',
    }
  },
  methods: {
    backTo(){
      let propFilters = this.propFilters
      this.$router.push({name:'app-users',params:{propFilters}})
    },
    statusUpdated(status){
      this.showModal = false
      this.accounts[this.accountIndex].status = status
    },
    kycStatusUpdated(){
      this.showKycModal = false
      this.sendCall()
    },
    updateStatus(account,accountIndex){
      this.accountId = account.id
      this.accountRow = account
      this.accountIndex = accountIndex
      this.accountStatus = account.status
      this.showModal = true
    },
    updateKycStatus(){
      this.showKycModal = true
    },
    sendCall() {
      this.makeRequest('post', 'v1/detail-merchant', {id: this.$route.params.id}, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            if(data){
              this.uuid = data.uuid
              this.kycId = data.id
              this.userRoles = data.user_roles
              this.accounts = data.accounts
              this.cards = data.cards
              this.userkycs = data.userkycs
            }
          }
        }

      });

    },
  },

}
</script>


